import { Modal, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Input } from "../../Controls/Input";
import { Button } from "../../Controls/Button";
import { HeaderText } from "../../Controls/HeaderText";
import { useEffect } from "react";
import { StaffUpdateReq } from "../../Data/ApiTypes";
import { DataEntitiesFacilityIntegrationParty, ServerTransferEnrolledIntegrationParty } from "../../shared/api/axios-client";
import { Select } from "../../Controls/Select";

interface AdminOperatorIntegrationModalProps {
    show: boolean;
    setShow: (show: boolean) => void;
    onSave: (data: ServerTransferEnrolledIntegrationParty) => void;
    initialData?: ServerTransferEnrolledIntegrationParty;
}

export default function AdminOperatorIntegrationEnrollModal({ show, setShow, onSave, initialData }: AdminOperatorIntegrationModalProps) {

    const { register, reset, formState: { errors }, handleSubmit } = useForm<ServerTransferEnrolledIntegrationParty>({
        defaultValues: initialData
    });

    useEffect(() => {
        reset(initialData);
    }, [initialData]);

    function submit(data: ServerTransferEnrolledIntegrationParty) {
        onSave(data);
        setShow(false);
    }

    return (
        <Modal show={show} centered onHide={() => setShow(false)}>
            <Form onSubmit={handleSubmit(submit)}>
                <Modal.Header closeButton>
                    <HeaderText>
                        Edit Integration Party
                    </HeaderText>
                </Modal.Header>
                <Modal.Body>
                    <Input
                        type="text"
                        label="External ID"
                        {...register("externalId")}
                        placeholder="External ID"
                        error={errors.externalId}
                    />

                    <Input
                        type="text"
                        label="Token"
                        {...register("token")}
                        placeholder="Token"
                        error={errors.token}
                    />

                    <Input
                        type="text"
                        label="API Secret"
                        {...register("apiSecret")}
                        placeholder="API Secret"
                        error={errors.apiSecret}
                    />
                    <Select label="Status" {...register("isActive")}>
                        <option value="">Select Integration</option>
                        {[{ id: 'true', name: 'Active' }, { id: 'false', name: 'Inactive' }].map((integration) => (
                            <option key={integration.id} value={integration.id}>
                                {integration.name}
                            </option>
                        ))}
                    </Select>
                </Modal.Body>
                <Modal.Footer className="d-flex">
                    <Button className="flex-grow-1" onClick={() => setShow(false)}>Cancel</Button>
                    <Button className="flex-grow-1 btn-main" type="submit">Save</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}